import React from "react";
import "./Searchnav.css";
import HomeIcon from "@material-ui/icons/Home";
import WelcomeName from "./WelcomeName";
function Searchnav() {

  const isStaging = window.location.href.split(".")[2] === "staging";
  const homeUrl = isStaging
    ? "https://atci.techexpressway.staging.accenture.com/"
    : "https://atci.entrylevellearning.accenture.com/home";

  return (
    <>
      <div role="region" aria-label="skip navigation">
        <a href="#main" className="cmp-skip-link">
          Skip to main content
        </a>
        {/* <a href="#footer" class="cmp-skip-link">Skip to footer</a> */}
      </div>
      <div class="searchnav-container">
        <div class="searchnav-wrap">
          <div class="searchnav-row">
            <div class="searchnav-box">
              <img
                src="/images/Acc_Logo_Black_Purple_RGB.png"
                tabIndex={0}
                class="acc-logo"
                alt="Accenture logo"
              />

              <p class="desktop-tag" tabIndex={0}>
                Learning & Talent Transformation
              </p>
              <p class="mobile-tag" tabIndex={0}>
                L&TT
              </p>
              {window.location.pathname !== "/home" && (
                <a
                  href={homeUrl}
                  aria-label="Go to home page"
                  className="home-link"
                  tabIndex={0}
                >
                  <HomeIcon />
                </a>
              )}
              {/* {window.location.pathname !== "/" && ( <a href="https://atci.entrylevellearning.accenture.com/" aria-label="Go to home page" className="home-link" tabIndex={0}><HomeIcon /></a>)} */}
            </div>
          </div>
          <div class="searchnav-row">
            <div class="searchnav-box" style={{ textAlign: "right" }}>
              <WelcomeName />
              <img src="/images/user2.jpg" class="user-img" alt="user-image" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Searchnav;
